

function getQuantidadeMaxAulasPermitidas(tipoDeEnsino) {
  switch(tipoDeEnsino) {
    case 'I': return 10;
    case 'F': return 6;
    case 'AEEouACP': return 10;
    default: return 6;
  }
}

export default {
  getQuantidadeMaxAulasPermitidas,
};
